import React, { useState } from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import MenuIcon from "@material-ui/icons/Menu";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import AppsIcon from "@material-ui/icons/Apps";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { Avatar, IconButton } from "@material-ui/core";

import SearchPad from "../search-pad/SearchPad";
function Header({ onClick }) {
  const [hideSearch, setHideSearch] = useState(false);
  const handleHide = () => {
    setHideSearch(!hideSearch);
  };

  return (
    <div className="header">
      {hideSearch && (
        <div className="header__customSearch">
          <SearchPad value={hideSearch} toggle={setHideSearch} back={true} />
        </div>
      )}
     {hideSearch?null: <div className="header__logo">
        <IconButton onClick={onClick}>
          <MenuIcon fontSize="small" />
        </IconButton>
        <Link to="/">
          <img src="/images/logo.png" alt="logo" />
        </Link>
        {/* <span className='header__logoCountry' >IN</span> */}
      </div>}
      {hideSearch?null:<div className="header__showSearch">
        <SearchPad />
      </div>}

     {hideSearch?null: <div className="header__options">
        <IconButton className="header__searchIcon" onClick={handleHide}>
          <SearchIcon />
        </IconButton>
        <VideoCallIcon className="header__optionHide" />

        <AppsIcon className="header__optionHide" />
        <NotificationsIcon className="header__optionHide" />
        <Avatar src="https://yt3.ggpht.com/yti/ANoDKi6B5zzA5uFCaNQaCPl7TN24RxJvoy7KR_QDUEFO0A=s88" />
      </div>}
    </div>
  );
}

export default Header;

// <form className="header__searchBox">
// <input
//   value={search.query}
//   onChange={(e) => {
//     setSearch({ query: e.target.value });
//   }}
//   type="text"
//   placeholder="Search"
// />
// <button onClick={handleSearch} type="submit">
//   <SearchIcon fontSize="small" />
// </button>
// </form>
